import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
})
export class HomeComponent {
    constructor(private router: Router) {}

    async ngOnInit() {}

    goToSchedule() {
        this.router.navigate(["/agenda"]);
    }

    goToExams() {
        this.router.navigate(["/exames"]);
    }

    goToCheckin() {
        this.router.navigate(["/checkin"]);
    }
}
